
export default {
    namespaced: true,
    state: {
        countries: [],
    },
    getters: {
        COUNTRIES: state => {
            return state.countries;
        },
    },
    mutations: {
        SET_COUNTRIES: (state, payload) => {
            return state.countries = payload;
        },
    },
    actions: {
        GET_DATA: async ({commit}, payload) => {
            payload.th.showOverlay ++;
            await payload.th.$store.dispatch('SEND_GET', {
                url: '/country',
                th: payload.th,
                showSuccessMessage: false,
                getSuccessResponse: (responseData) => {
                    console.log('responseData')
                    console.log(responseData)
                    commit('SET_COUNTRIES', responseData.data);
                    payload.th.isReady = true
                },
                getResponse: () => {
                    payload.th.showOverlay --;
                },
            });
        }
    }
}